import React, { PureComponent } from 'react';

import { Edit as EditIcon, Delete as DeleteIcon } from '@mui/icons-material';

import { IconButton, Tooltip, Zoom } from '@mui/material';

import TableEnhancedContainer from '../../../../common/components/TableEnhanced/TableEnhancedContainer';
import ConfirmationDialog from '../../../../common/components/ConfirmationDialog/ConfirmationDialog';
import CreationDialog from '../CreationDialog/CreationDialog';
import PermissionsCheck from '../../../../common/components/PermissionsCheck/PermissionsCheck';
import PermissionsEnum from '../../../../common/constants/PermissionsEnum';

class RegionsManager extends PureComponent {
  constructor(props) {
    super(props);
    this.columnsConfig = [
      {
        name: 'Name',
        key: 'Name',
        type: 'string',
        visible: true,
        filterable: true,
        sortable: true,
      },
      {
        name: 'No of users',
        key: 'NumberOfUsers',
        type: 'number',
        visible: true,
        filterable: true,
        sortable: true,
      },
      {
        name: 'No of instruments',
        key: 'NumberOfInstruments',
        type: 'number',
        visible: true,
        filterable: true,
        sortable: true,
      },
      {
        name: 'Actions',
        key: 'Actions',
        type: 'markup',
        markup: (el, col, elIndex, colIndex) => {
          return (
            <div>
              <Tooltip disableInteractive TransitionComponent={Zoom} title="Edit">
                <IconButton
                  size="large"
                  button="true"
                  component="span"
                  key={1}
                  onClick={(event) => {
                    return props.onEditCallback(event, el);
                  }}
                  data-qa="qa-edit-region"
                >
                  <EditIcon />
                </IconButton>
              </Tooltip>
              <PermissionsCheck permission={PermissionsEnum.EDIT_REGIONS}>
                <Tooltip disableInteractive TransitionComponent={Zoom} title="Delete">
                  <IconButton
                    size="large"
                    key={2}
                    onClick={(event) => {
                      return props.onDeleteCallback(event, el);
                    }}
                    data-qa="qa-delete-region"
                  >
                    <DeleteIcon />
                  </IconButton>
                </Tooltip>
              </PermissionsCheck>
            </div>
          );
        },
        style: { width: '10rem' },
        visible: true,
        filterable: false,
        sortable: false,
      },
    ];
  }

  render() {
    return (
      <div>
        <ConfirmationDialog
          onClickCancel={this.props.showConfirmDialog.cancel}
          onClickMainAction={this.props.showConfirmDialog.action}
          open={this.props.showConfirmDialog.show}
          messageToConfirm={this.props.messageToConfirm}
          title={this.props.showConfirmDialog.title}
          mainActionLabel={this.props.showConfirmDialog.mainActionLabel}
          disableMainAction={this.props.showConfirmDialog.disableMainAction}
        />

        <CreationDialog
          onClickCancel={this.props.showDialog.cancel}
          onClickMainAction={this.props.showDialog.action}
          open={this.props.showDialog.show}
          title={this.props.showDialog.title}
          disableMainAction={
            !(this.props.errorRegionName === '' && this.props.regionName && !this.props.isFetching)
          }
          textfieldName={'Region name'}
          errorText={this.props.errorRegionName}
          onChangeCallback={this.props.onChangeCallback}
          propertyToEdit={'Name'}
        />

        <TableEnhancedContainer
          data={this.props.regionList}
          columns={this.columnsConfig}
          enableHideColumns={false}
          enableActionButtons={false}
          onClickRow={this.props.onRegionRowSelected}
          data-qa="qa-table-regions"
        />
      </div>
    );
  }
}

export default RegionsManager;
